import { createIcon } from '@chakra-ui/react';

export const MastercardIcon = createIcon({
  displayName: 'MastercardIcon',
  path: (
    <>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 26 18"
        fill="none"
      >
        <rect x="0.5" y="0.5" width="25" height="17" rx="3.5" fill="white" stroke="#E4E4E7" />
        <path
          d="M16.4741 3.75C19.2734 3.75017 21.5422 6.06777 21.5424 8.92676C21.5424 11.786 19.2735 14.1043 16.4741 14.1045C15.2189 14.1045 14.0713 13.637 13.186 12.8652C12.3007 13.6371 11.1531 14.1044 9.8979 14.1045C7.09832 14.1045 4.82857 11.7861 4.82857 8.92676C4.82882 6.06767 7.09848 3.75 9.8979 3.75C11.1529 3.75006 12.3008 4.21665 13.186 4.98828C14.0712 4.21676 15.2191 3.75 16.4741 3.75Z"
          fill="#ED0006"
        />
        <path
          d="M16.4738 3.75C19.2732 3.75001 21.5429 6.06768 21.5431 8.92676C21.5431 11.7861 19.2734 14.1045 16.4738 14.1045C15.2185 14.1045 14.071 13.6371 13.1857 12.8652C14.2749 11.9156 14.9669 10.504 14.9669 8.92676C14.9668 7.34945 14.2751 5.93778 13.1857 4.98828C14.071 4.21668 15.2188 3.75 16.4738 3.75Z"
          fill="#F9A000"
        />
        <path
          d="M13.186 4.98828C14.2754 5.93788 14.9672 7.3503 14.9672 8.92773C14.9671 10.5047 14.275 11.9157 13.186 12.8652C12.0968 11.9157 11.4049 10.5049 11.4047 8.92773C11.4047 7.35016 12.0964 5.93788 13.186 4.98828Z"
          fill="#FF5E00"
        />
      </svg>
    </>
  ),
});
